import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inviteEvaluators: {
    id: `app.containers.ScorecardModals.inviteEvaluators`,
    defaultMessage: 'Invite evaluators',
    description: 'Title of the modal for inviting scorecard evaluators',
  },
});
